<template>
  <a-spin tip="Loading..." :spinning="isLoading" size="large">
    <div class="spin-content">
      <div class="row">
        <div class="col-12 col-md-6 d-flex flex-column justify-content-between">
          <div v-if="!empty(cardUrl.proofUrl)">
            <h3>Proof Image</h3>
            <img :src="cardUrl.proofUrl" alt="back" class="w-100 my-1 my-sm-0 mr-sm-1 cursor-pointer" @click="viewImage(cardUrl.proofUrl, 'Proof Image')" />
          </div>
          <template v-else>
            <div>
              <h3>Card Front</h3>
              <img :src="cardUrl.cardFrontUrl" alt="front" class="w-100 my-1 my-sm-0 mr-sm-1 cursor-pointer" @click="viewImage(cardUrl.cardFrontUrl, 'Card Front')" />
            </div>
            <div>
              <h3>Card Back</h3>
              <img :src="cardUrl.cardBackUrl" alt="back" class="w-100 cursor-pointer" @click="viewImage(cardUrl.cardBackUrl, 'Card Back')" />
            </div>
          </template>
        </div>
        <div class="col-12 col-md-6 d-flex flex-column justify-content-between">
          <div class="d-flex flex-column">
            <h3>Sign To Approve & Ship Cards</h3>
            <signature-pad ref="signature" name="signature" />
            <a-button size="large" type="primary" class="text-center p-2 align-self-end h-auto" ghost @click="doApprove">Approve & Ship</a-button>
          </div>

          <div class="d-flex flex-column">
            <h3>Request Changes</h3>
            <a-textarea v-model="requestChanges" :rows="10" class="my-2" allow-clear placeholder="Type requested changes here..." />
            <a-button size="large" type="primary" class="text-center p-2 align-self-end h-auto" ghost @click="doProofChanges">Submit Changes</a-button>
          </div>
        </div>
      </div>
    </div>
  </a-spin>
</template>
<script>
import SignaturePad from '@/components/SignaturePad';
import AdminService from '@/services/AdminService';
import { mapGetters } from 'vuex';
import { empty } from '@/utils';
export default {
  props: {
    cardUrl: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    SignaturePad,
  },
  computed: {
    ...mapGetters(['user']),
  },
  data: () => ({
    requestChanges: '',
    isLoading: false,
  }),
  methods: {
    empty,
    async doApprove() {
      try {
        this.isLoading = true;
        const { data, isEmpty } = this.$refs.signature.submit();
        if (!isEmpty) {
          const resp = await AdminService.cardOrder(this.user.userId).approveCards(this.data.id, data);
          console.log({ resp });
          this.$emit('onSuccess');
          // this.$notification['success']({
          //   message: 'Approved',
          //   description: 'You have successfully approved card!',
          // });
          this.$notification['success']({
            message: 'Successfully!',
            description: 'Thank you for approving your card order, we will print and ship your order.',
          });
        }
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },
    async doProofChanges() {
      try {
        if (!empty(this.requestChanges)) {
          this.isLoading = true;
          const resp = await AdminService.cardOrder(this.user.userId).proofChanges(this.data.id, this.requestChanges);
          console.log({ resp });
          this.requestChanges = '';

          this.$notification['success']({
            message: 'Successfully!',
            description: 'Thank you, one of our design team members will be in contact with you.',
          });
          // this.$success({
          //   title: '',
          //   centered: true,
          //   iconType: false,
          //   class: 'custom-result',
          //   // JSX support
          //   content: <a-result status="success" title="Successfully!" sub-title="Thank you, one of our design team members will be in contact with you" />,
          // });
        }
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },
    viewImage(url, title) {
      this.$emit('onOpenImage', { url, title });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ textarea {
  resize: none !important;
}
</style>
<style lang="scss">
.custom-result {
  .ant-modal-confirm-body > .anticon {
    display: none;
  }
  .ant-modal-confirm-content {
    padding: 0;
    margin: 0 !important;
  }
}
</style>
